import React from 'react';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers-v5/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers-v5/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers-v5/DatePicker';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';
import { InputAdornment } from '@mui/material';

export default function GcDatePicker(props) {
	const {
		value: initialDate = null,
		returnType = 'date', // ou string - retourne un object JS Date ou une chaine yyyy-mm-dd
		renderInput = ({ inputRef, inputProps, InputProps }) => (
			<TextField
				{...inputProps}
				ref={inputRef}
				type="text"
				value={inputProps.value}
				size="small"
				className="d-block bg-white form-control w-100"
				InputProps={{
					endAdornment: <InputAdornment position='end'>{InputProps?.endAdornment}</InputAdornment>,
					placeholder: ''
				}}
				sx={{
					...inputProps.sx,
					'& .MuiInputBase-root': {
						width: '100%'
					}
				}}
			/>
		),
		parentFunction = null
	} = props;

	const [selectedDate, setSelectedDate] = React.useState(initialDate);

	React.useEffect(() => {
		setSelectedDate(dayjs(String(initialDate)));
	}, [initialDate]);


	const checkValue = (newValue) => {

		if(returnType == 'string') {
			newValue = parseDayjsDate(newValue)
		} else {
			newValue = newValue?.$d;
		}

		return newValue;
	}

	const parseDayjsDate = (dayjsobj) => {
		if (dayjsobj.$isDayjsObject) {
			const day = dayjsobj.$D;
			const month = ('0' + (dayjsobj.$M + 1)).slice(-2);
			return dayjsobj.$y + '-' + month + '-' + day;
		}
		return '';
	}

	const handleChange = (newValue) => {
		setSelectedDate(newValue);
		if(newValue.isValid()) {
			let checkedValue = checkValue(newValue);

			parentFunction(checkedValue, props.slug)
		}
		
	}

	return (
		<ThemeProvider theme={backYouTheme}>
			<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ENV.lang.split('_').shift()}>
				<DatePicker
					{...props}
					value={selectedDate ?? null}
					onChange={(newValue) => { handleChange(newValue) }}
					renderInput={renderInput}
					views={['year', 'month', 'day']}
				/>
			</LocalizationProvider>
		</ThemeProvider>
	);
}